/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DDiagramSerializedItem } from "../../d-diagram-serialized";
import { EShapeResourceManagerDeserialization } from "../e-shape-resource-manager-deserialization";
import { deserializeBase } from "./deserialize-base";
import { EShapeRectanglePivoted } from "./e-shape-rectangle-pivoted";

export const deserializeRectanglePivoted = (
	item: DDiagramSerializedItem,
	manager: EShapeResourceManagerDeserialization,
	shape?: EShapeRectanglePivoted
): Promise<EShapeRectanglePivoted> | EShapeRectanglePivoted => {
	return deserializeBase(item, manager, shape || new EShapeRectanglePivoted());
};
